var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"KnFormFieldRow contentModule hSpace hSpace--formRow",class:_vm.elmClasses,attrs:{"name":"KnFormFieldRow"}},[_c('div',{staticClass:"KnFormFieldRow__inner contentModule__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }